import { render, staticRenderFns } from "./TenderPzList.vue?vue&type=template&id=178992a1&scoped=true&"
import script from "./TenderPzList.vue?vue&type=script&lang=js&"
export * from "./TenderPzList.vue?vue&type=script&lang=js&"
import style0 from "./TenderPzList.vue?vue&type=style&index=0&id=178992a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178992a1",
  null
  
)

export default component.exports